export default __webpack_public_path__ + "b59dd8a17707a7ba7f1be4c37a521547.svg";